import { ClickAwayListener, Grow, Tooltip } from "@mui/material";
import styles from "./styles";
import { classVeryIconGoogle } from "../../common/v2/VeryIconGoogle/classVeryIconGoogle";
import { useState, useEffect } from "react";
import { VeryIconGoogle } from "../../common/v2/VeryIconGoogle";
import { isStringEmpty } from "../../../utils/handler_validations";

const getColorItemTemplate = () => ({ label: "", value: "" });

const propsTemplate = () => ({
  textError: "",
  selectedValue: "",
  onChangeValue: (newValue = "") => {},
});

const SelectColor = (props = propsTemplate()) => {
  const [showMenu, setShowMenu] = useState(false);
  const [options] = useState([
    { label: "Amarillo", value: "AMARILLO" },
    { label: "Azul", value: "AZUL" },
    { label: "Beige", value: "BEIGE" },
    { label: "Blanco", value: "BLANCO" },
    { label: "Café", value: "CAFE" },
    { label: "Gris", value: "GRIS" },
    { label: "Morado", value: "MORADO" },
    { label: "Naranja", value: "NARANJA" },
    { label: "Negro", value: "NEGRO" },
    { label: "Plata", value: "PLATA" },
    { label: "Rojo", value: "ROJO" },
    { label: "Verde", value: "VERDE" },
  ]);

  const getColor = (value = "") => {
    const item = { label: "", divColorCSS: "divColor" };
    switch (value) {
      case "AMARILLO":
        item.divColorCSS += " YELLOW";
        item.label = "Amarillo";
        break;
      case "AZUL":
        item.divColorCSS += " BLUE";
        item.label = "Azul";
        break;
      case "BEIGE":
        item.divColorCSS += " BEIGE";
        item.label = "Beige";
        break;
      case "BLANCO":
        item.divColorCSS += " WHITE";
        item.label = "Blanco";
        break;
      case "CAFE":
        item.divColorCSS += " BROWN";
        item.label = "Café";
        break;
      case "GRIS":
        item.divColorCSS += " GRAY";
        item.label = "Gris";
        break;
      case "MORADO":
        item.divColorCSS += " PURPLE";
        item.label = "Morado";
        break;
      case "NARANJA":
        item.divColorCSS += " ORANGE";
        item.label = "Naranja";
        break;
      case "NEGRO":
        item.divColorCSS += " BLACK";
        item.label = "Negro";
        break;
      case "PLATA":
        item.divColorCSS += " SILVER";
        item.label = "Plata";
        break;
      case "ROJO":
        item.divColorCSS += " RED";
        item.label = "Rojo";
        break;
      case "VERDE":
        item.divColorCSS += " GREEN";
        item.label = "Verde";
        break;
    }
    return item;
  };

  const renderOption = (colorItem = getColorItemTemplate()) => {
    const classesCSS = ["btnOption"];
    if (props.selectedValue === colorItem.value)
      classesCSS.push("colorSelected");
    const color = getColor(colorItem.value);

    return (
      <styles.BtnColor
        className={classesCSS.join(" ")}
        onClick={() => {
          setShowMenu(false);
          props.onChangeValue && props.onChangeValue(colorItem.value);
        }}
      >
        <div className={color.divColorCSS} />
        <label>{color.label}</label>
      </styles.BtnColor>
    );
  };

  const selectedColor = getColor(props.selectedValue);

  return (
    <ClickAwayListener onClickAway={() => setShowMenu(false)}>
      <styles.DivMain>
        <Tooltip
          PopperProps={{ disablePortal: true }}
          open={showMenu}
          placement="bottom-start"
          disableFocusListener
          disableHoverListener
          disableTouchListener
          TransitionComponent={Grow}
          TransitionProps={{ timeout: 500 }}
          title={options.map((color) => renderOption(color))}
        >
          <div className="divSelect">
            <label className="txt-title">Color</label>
            <styles.BtnColor
              className={"btnSelect"}
              onClick={() => setShowMenu(!showMenu)}
            >
              <div className={selectedColor.divColorCSS} />
              <label>
                {isStringEmpty(selectedColor.label)
                  ? "Elige un color"
                  : selectedColor.label}
              </label>
              <VeryIconGoogle
                name="expand_more"
                type={classVeryIconGoogle.ICON_TYPE.SYMBOLS_ROUNDED}
                size={21}
              />
            </styles.BtnColor>
            {!isStringEmpty(props.textError) && (
              <label className="txt-error">{props.textError}</label>
            )}
          </div>
        </Tooltip>
      </styles.DivMain>
    </ClickAwayListener>
  );
};

export default SelectColor;
